export default __webpack_public_path__ + "static/media/Noctarus.6679d47e.png";